module.exports = __webpack_public_path__ + "img/euro-circle.ce1d0683.svg";